<template>
  <form ref="form" action="#" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <div class="l-page l-page--message-edit-condition-confirm">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <div class="c-title__text c-title__text--blue u-fs34">
              配信済みメッセージの確認
            </div>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit-confirm">
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  プッシュ名
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ message.message_name }}
                </div>
              </div>
              <div v-if="messageGroupName" class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  グループ名
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ messageGroupName }}
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  プッシュ対象
                </div>
                <div class="c-tag">
                  <ul class="c-tag-list">
                    <li
                      v-if="message.service_type == 2"
                      class="c-tag-list__item c-tag-list__item--green"
                    >
                      ブラウザ
                    </li>
                    <li
                      v-if="message.service_type == 4"
                      class="c-tag-list__item c-tag-list__item--green"
                    >
                      カート
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-content">
          <div
            class="p-message-edit-confirm p-message-edit-confirm--preview"
          >
            <div class="c-title c-title--left">
              <div class="c-title__text u-fs24">配信内容</div>
              <div class="c-text u-fs--s">
                実際の配信メッセージと表示が異なることがあります
              </div>
            </div>
            <div class="p-message-preview-list">
              <div class="p-message-preview-list__block">
                <div class="p-message-preview__title">
                  <div class="c-text u-text-bold">
                    PCでの配信例
                  </div>
                </div>
                <!-- プレビュー: PC -->
                <message-preview
                  :title="message.message_title"
                  :text="message.message_text"
                  :url="message.click_url"
                  :icon-url="message.image_url"
                  :large-image-url="message.large_image_url"
                  :has-button-a="
                    message.action_button_text_a != null
                  "
                  :has-button-b="
                    message.action_button_text_b != null
                  "
                  :action-button-text-a="
                    message.action_button_text_a
                  "
                  :action-button-url-a="
                    message.action_button_url_a
                  "
                  :action-button-text-b="
                    message.action_button_text_b
                  "
                  :action-button-url-b="
                    message.action_button_url_b
                  "
                />
              </div>
              <div class="p-message-preview-list__block">
                <div class="p-message-preview__title">
                  <div class="c-text u-text-bold">
                    スマホでの配信例
                  </div>
                </div>
                <message-preview-sp
                  :title="message.message_title"
                  :text="message.message_text"
                  :url="message.click_url"
                  :icon-url="message.image_url"
                  :large-image-url="message.large_image_url"
                  :badge-url="message.badge_url"
                  :has-button-a="
                    message.action_button_text_a != null
                  "
                  :has-button-b="
                    message.action_button_text_b != null
                  "
                  :action-button-text-a="
                    message.action_button_text_a
                  "
                  :action-button-url-a="
                    message.action_button_url_a
                  "
                  :action-button-text-b="
                    message.action_button_text_b
                  "
                  :action-button-url-b="
                    message.action_button_url_b
                  "
                />
              </div>
            </div>
            <div
              class="p-message-edit-confirm-list"
              style="margin-top: 0px"
            >
              <div
                class="p-message-edit-confirm-list__item"
                style="border-top: 1px #ccc solid"
              >
                <div class="p-message-edit-confirm__title">
                  タイトル
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ message.message_title }}
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  本文
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ message.message_text }}
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  遷移先URL
                </div>
                <div class="p-message-edit-confirm__text">
                  <a
                    :href="message.click_url"
                    target="_blank"
                    style="
                                            color: #0089e5;
                                            display: flex;
                                            text-decoration: underline;
                                        "
                  >
                    <span
                      class="c-icon c-icon--blue-link-1 u-wh16"
                      style="
                                                margin: 5px 5px 0 0;
                                                flex: none;
                                            "
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <use
                          xlink:href="/assets/img/sprite.svg#external-link"
                        />
                      </svg>
                    </span>
                    <span style="max-width: 720px">{{
                      message.click_url
                    }}</span>
                  </a>
                </div>
              </div>

              <div
                v-if="
                  message.action_button_text_a &&
                    message.action_button_url_a
                "
                class="p-message-edit-confirm-list__item"
              >
                <div
                  class="p-message-edit-confirm__title"
                  style="padding-left: 20px"
                >
                  ボタン1
                </div>
                <div
                  class="p-message-edit-confirm__text"
                  style="display: flex"
                >
                  <div
                    style="margin-right: 20px; width: 130px"
                  >
                    {{ message.action_button_text_a }}：
                  </div>
                  <a
                    :href="message.action_button_url_a"
                    target="_blank"
                    style="
                                            color: #0089e5;
                                            display: flex;
                                            text-decoration: underline;
                                            width: fit-content;
                                        "
                  >
                    <span
                      class="c-icon c-icon--blue-link-1 u-wh16"
                      style="
                                                margin: 5px 5px 0 0;
                                                flex: none;
                                            "
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <use
                          xlink:href="/assets/img/sprite.svg#external-link"
                        />
                      </svg>
                    </span>
                    {{ message.action_button_url_a }}
                  </a>
                </div>
              </div>

              <div
                v-if="
                  message.action_button_text_b &&
                    message.action_button_url_b
                "
                class="p-message-edit-confirm-list__item"
              >
                <div
                  class="p-message-edit-confirm__title"
                  style="padding-left: 20px"
                >
                  ボタン2
                </div>
                <div
                  class="p-message-edit-confirm__text"
                  style="display: flex"
                >
                  <div
                    style="margin-right: 20px; width: 130px"
                  >
                    {{ message.action_button_text_b }}：
                  </div>
                  <a
                    :href="message.action_button_url_b"
                    target="_blank"
                    style="
                                            color: #0089e5;
                                            display: flex;
                                            text-decoration: underline;
                                            width: fit-content;
                                        "
                  >
                    <span
                      class="c-icon c-icon--blue-link-1 u-wh16"
                      style="
                                                margin: 5px 5px 0 0;
                                                flex: none;
                                            "
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <use
                          xlink:href="/assets/img/sprite.svg#external-link"
                        />
                      </svg>
                    </span>
                    {{ message.action_button_url_b }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-content">
          <div
            class="p-message-edit-confirm p-message-edit-confirm--details"
          >
            <div class="c-title">
              <div class="c-title__text u-fs24">配信設定</div>
            </div>

            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  プッシュメッセージの動作
                </div>
                <div
                  v-if="message.require_interaction == 0"
                  class="p-message-edit-confirm__text"
                >
                  一定時間後に自動最小化
                </div>
                <div
                  v-if="message.require_interaction == 1"
                  class="p-message-edit-confirm__text"
                >
                  ユーザーがアクションを起こすまで表示
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  配信の設定
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ getDeliverString() }}
                </div>
              </div>
              <div
                v-if="message.message_deliver.deliver_type == 1"
                class="p-message-edit-confirm-list__item"
              >
                <div class="p-message-edit-confirm__title">
                  配信される日時
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ getSendStartDateTimeString() }}
                </div>
              </div>
              <template
                v-if="message.message_deliver.deliver_type == 3"
              >
                <div class="p-message-edit-confirm-list__item">
                  <div class="p-message-edit-confirm__title">
                    配信時刻
                  </div>
                  <div class="p-message-edit-confirm__text">
                    {{ getSendTimeString() }}
                  </div>
                </div>
                <div class="p-message-edit-confirm-list__item">
                  <div class="p-message-edit-confirm__title">
                    配信開始
                  </div>
                  <div class="p-message-edit-confirm__text">
                    {{ getSendStartDateString() }}
                  </div>
                </div>
                <div class="p-message-edit-confirm-list__item">
                  <div class="p-message-edit-confirm__title">
                    配信終了
                  </div>
                  <div class="p-message-edit-confirm__text">
                    {{ getSendEndDateString() }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="l-main-content">
          <div
            class="p-message-edit-confirm p-message-edit-confirm--details"
          >
            <div class="c-title">
              <div class="c-title__text u-fs24">配信条件</div>
            </div>
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  配信条件
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ getConditionString() }}
                </div>
              </div>
              <div
                v-show="!isTopicDelivery()"
                class="p-message-edit-confirm-list__item"
              >
                <div class="p-message-edit-confirm__title">
                  接続条件
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ getMessageConditionJoinTypeString() }}
                </div>
              </div>
              <template v-if="hasMessageCondition()">
                <div
                  v-for="(messageCondition, loopIndex1) in message.message_conditions"
                  :key="loopIndex1"
                  class="p-message-edit-confirm-list__item"
                >
                  <div class="p-message-edit-confirm__title">
                    セグメント条件
                  </div>
                  <ul
                    class="p-message-edit-confirm-segment-list"
                  >
                    <li
                      class="p-message-edit-confirm-segment-list__item"
                    >
                      選択：{{
                        getConditionJoinTypeString(
                          messageCondition.condition
                        )
                      }}
                      条件
                    </li>
                    <li
                      class="p-message-edit-confirm-segment-list__item"
                    >
                      {{
                        getConditionTypeString(
                          messageCondition.condition
                        )
                      }}
                    </li>
                    <li
                      v-for="(conditionDetail, loopIndex2) in getConditionDetails(
                        messageCondition.condition
                      )"
                      :key="loopIndex2"
                      class="p-message-edit-confirm-segment-list__item"
                      style="word-break: break-all"
                    >
                      {{
                        conditionInfo
                          .conditionOperatorTypes[
                            conditionDetail
                              .condition_operation
                          ]
                      }}
                      /
                      {{
                        getDescription(conditionDetail)
                      }}
                    </li>
                  </ul>
                </div>
              </template>
              <div
                v-if="hasTopicMessageCondition()"
                class="p-message-edit-confirm-list__item"
              >
                <div class="p-message-edit-confirm__title">
                  属性条件
                </div>
                <ul class="p-message-edit-confirm-segment-list">
                  <li
                    v-for="(topicConditionDetail, loopIndex3) in getTopicConditionDetails()"
                    :key="loopIndex3"
                    class="p-message-edit-confirm-segment-list__item"
                  >
                    {{
                      getTopicConditionDetailTypeString(
                        topicConditionDetail
                      )
                    }}
                    :
                    {{
                      getTopicConditionDetailValueString(
                        topicConditionDetail
                      )
                    }}
                  </li>
                </ul>
              </div>
              <template v-if="hasMessageCustomCondition()">
                <div class="p-message-edit-confirm-list__item">
                  <div class="p-message-edit-confirm__title">
                    カスタム条件
                  </div>
                  <ul
                    class="p-message-edit-confirm-segment-list"
                  >
                    <li
                      v-for="(messageCustomCondition, loopIndex4) in message.message_custom_conditions"
                      :key="loopIndex4"
                      class="p-message-edit-confirm-segment-list__item"
                    >
                      {{
                        getMessageCustomConditionString(
                          messageCustomCondition
                        )
                      }}
                    </li>
                  </ul>
                </div>
              </template>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend"></div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--gray u-w320 u-h50 u-fs20"
            type="button"
            name="prev"
            value="prev"
            @click="onBackClick()"
          >
            <p class="c-btn__text">配信メッセージの一覧に戻る</p>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import '../molecules/ReachCount.vue';
import store from '../../funcs/store.js';

export default {
  components: {

  },
  props: {
    csrfToken: String,
    saveMessageUrl: String,
    breadcrumbData: Array,
    message: Object,
    conditionInfo: Object,
  },
  data() {
    return {
      useTargetReachCount:
        this.message.service_type == 2 &&
        (this.conditionInfo.useTargetReachCount ||
          store.state.user.isSystemAdminEdit),
    };
  },
  computed: {
    messageGroupName() {
      return this.getMessageGroupName();
    },
  },
  mounted: function () {
    import('../../funcs/pages/message-add-condition').then((module) => {
      module.MessageAddCondition();
    });
  },
  methods: {
    onBackClick: function () {
      location.href = '/coins-admin/message';
    },
    getDeliverString: function () {
      let deliverType = this.message.message_deliver.deliver_type;
      let deliverString = '';
      if (deliverType == 1) {
        // 予約
        deliverString = '予約';
      } else if (deliverType == 3) {
        // 定期
        let regularType = this.message.message_deliver.regular_type;
        let dayOfTheWeek = ['日', '月', '火', '水', '木', '金', '土'];
        for (let day = 0; day < 7; day++) {
          if (regularType.substring(day, day + 1) == '1') {
            if (deliverString) {
              deliverString += '・';
            }
            deliverString += dayOfTheWeek[day];
          }
        }
        deliverString = '定期配信：' + deliverString;
      } else if (deliverType == 4) {
        // 即時
        deliverString = '即時';
      }
      return deliverString;
    },
    getSendStartDateTimeString: function () {
      let sendStartDate = this.message.message_deliver.send_start_date;
      return (
        this.getDisplayDate(sendStartDate) +
        ' ' +
        this.getDisplayTime(sendStartDate)
      );
    },
    getSendStartDateString: function () {
      let sendStartDate = this.message.message_deliver.send_start_date;
      return this.getDisplayDate(sendStartDate);
    },
    getSendEndDateString: function () {
      let sendEndDate = this.message.message_deliver.send_end_date;
      return this.getDisplayDate(sendEndDate);
    },
    getSendTimeString: function () {
      return this.message.message_deliver.target_start_time;
    },
    getConditionString: function () {
      let conditionString;
      if (this.message.has_custom_list) {
        conditionString = `カスタムリスト配信（配信対象 ${this.message.custom_list_distribution_count} 件）`;
      } else if (this.message.topic_flag == 1) {
        // ALL
        conditionString = '全配信';
      } else {
        conditionString = 'セグメント配信';
      }

      return conditionString;
    },
    isTopicDelivery: function () {
      return this.message.topic_flag == 1;
    },
    getMessageConditionJoinTypeString: function () {
      if (this.message.condition_join_type === 'OR') {
        return 'または(OR)';
      }
      return 'かつ(AND)';
    },
    getMessageCustomConditionString: function (messageCustomCondition) {
      let messageCustomConditionString = '';
      let operatorString = '';
      switch (messageCustomCondition.condition_operation) {
      case 'lte':
        operatorString = 'になるまで';
        break;
      case 'gte':
        operatorString = 'よりも多くなったら';
        break;
      case 'eq':
        operatorString = 'のとき';
        break;
      }

      switch (messageCustomCondition.condition_key) {
      case 'click':
        messageCustomConditionString =
          'サイト全体で、クリック数が累計 ' +
          messageCustomCondition.condition_value +
          '回' +
          operatorString;
        break;
      case 'impression':
        messageCustomConditionString =
          'サイト全体で、表示数が累計 ' +
          messageCustomCondition.condition_value +
          '回' +
          operatorString;
        break;
      case 'frequency':
        messageCustomConditionString =
          '１ユーザーの、訪問回数が ' +
          messageCustomCondition.condition_value +
          '回/日' +
          operatorString;
        break;
      }
      return messageCustomConditionString;
    },
    hasMessageCondition: function () {
      return (
        this.message.message_conditions &&
        this.message.message_conditions.length > 0
      );
    },
    hasTopicMessageCondition: function () {
      return this.message.topic_message_condition;
    },
    hasMessageCustomCondition: function () {
      return (
        this.message.message_custom_conditions &&
        this.message.message_custom_conditions.length > 0
      );
    },
    getCondition: function () {
      let condition = null;
      if (
        this.message.message_conditions &&
        this.message.message_conditions.length > 0
      ) {
        let messageCondition = this.message.message_conditions[0];
        if (messageCondition.condition) {
          condition = messageCondition.condition;
        }
      }
      return condition;
    },
    getConditionDetails: function (condition) {
      let conditionDetails = [];
      if (condition) {
        conditionDetails = condition.condition_details;
      }
      return conditionDetails;
    },
    getConditionJoinTypeString: function (condition) {
      let conditionJoinTypeString = '';
      //let condition = this.getCondition();
      if (condition) {
        conditionJoinTypeString = condition.condition_join_type;
      }
      return conditionJoinTypeString;
    },
    getConditionTypeString: function (condition) {
      let conditionTypeString = '';
      //let condition = this.getCondition();
      if (condition) {
        let conditionDetails = condition.condition_details;
        if (conditionDetails && conditionDetails.length > 0) {
          let conditionKey = conditionDetails[0].condition_key;
          conditionTypeString =
            this.conditionInfo.conditionKeyTypes[conditionKey] +
            '：' +
            this.conditionInfo.conditionKeyExplanations[
              conditionKey
            ];
        }
      }
      return conditionTypeString;
    },
    getDescription: function (conditionDetail) {
      // 変換が必要なければvalueそのまま
      let description = conditionDetail.condition_value;
      if (
        this.conditionInfo.conditionKeyOptions[
          conditionDetail.condition_key
        ]
      ) {
        let options =
          this.conditionInfo.conditionKeyOptions[
            conditionDetail.condition_key
          ];

        if (options[conditionDetail.condition_value]) {
          // 変換が必要なら変換した値
          description = options[conditionDetail.condition_value];
        }
      }
      return description;
    },
    getTopicConditionDetails: function () {
      let topicConditionDetails = [];
      if (this.message.topic_message_condition) {
        let topicMessageCondition =
          this.message.topic_message_condition;
        if (topicMessageCondition.topic_condition) {
          topicConditionDetails =
            topicMessageCondition.topic_condition
              .topic_condition_details;
        }
      }
      return topicConditionDetails;
    },
    getMessageGroupName: function () {
      return this.message.message_group_message?.message_group?.group_name
    },
  },
};
</script>
